import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialTiktokIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialTiktok",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.74 6.41a7.68 7.68 0 0 1-3.49-6.42h-5.5v22.05a4.637 4.637 0 0 1-4.63 4.45c-.77 0-1.5-.19-2.14-.53a4.63 4.63 0 0 1-2.48-4.09c0-2.55 2.07-4.62 4.62-4.62.48 0 .93.08 1.36.21v-5.62c-.45-.06-.9-.1-1.36-.1-5.58 0-10.13 4.54-10.13 10.13 0 3.43 1.71 6.46 4.32 8.29a10 10 0 0 0 5.8 1.83c5.58 0 10.13-4.54 10.13-10.13V10.68c2.16 1.55 4.8 2.46 7.65 2.46v-5.5c-1.54 0-2.97-.46-4.17-1.24Z"
    })
  }));
};
SocialTiktokIcon.displayName = 'SocialTiktokIcon';